<template>
  <div class="maintenance-container">
    <img
      src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/MANTENCION_MI-SECURITY-15-11-2024.png"
      alt="Mantenimiento"
      class="maintenance-image"
    />
  </div>
</template>

<script>
export default {
  name: "MaintenanceScreen",
};
</script>

<style scoped>
.maintenance-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.maintenance-image {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
}
</style>
